export function getFilenameFromUrl(url) {
    try {
        const pathname = new URL(url).pathname;
        const lastSegment = pathname.split('/').pop() ?? '';
        return decodeURIComponent(lastSegment) || url;
    }
    catch {
        const lastSegment = url.split('/').pop() ?? '';
        return decodeURIComponent(lastSegment) || url;
    }
}
//# sourceMappingURL=AssetMenuItemsShared.js.map